import { find, omitBy, isNil, toUpper } from 'lodash';
import idType from 'Data/id-type.json';

export default function serverData(data: any) {
  const selectedIdType = find(idType, (o) => {
    o.DESC.replace(' ', '_');
    return toUpper(o.DESC) === data.idType
  })

  let otherDocuments: any;

  if (data.provisionalRegistrationNumber) {
    otherDocuments = omitBy({
      MMCNo: data.provisionalRegistrationNumber,
      APCNo: data.apcNo,
      APCRenewYear: data.apcYear
    }, isNil)
  }

  return omitBy(
    {
      IdType: selectedIdType ? selectedIdType.ID : 0,
      IdNo: data.idNumber,
      MyKadDataUrl: data.idImageData,
      MMCDataUrl: data.certImageData,
      MMC: otherDocuments
    },
    isNil
  );
}
